/**
 * Tourniquet Drill: longer on the floor before it stops mattering.
 *
 * Reads as a solo perk and is a co-op one. Thirty percent longer bleeding out is thirty percent
 * more of the map a team mate can be crossing when you go down.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const TOURNIQUET_DRILL = {
  id: 'tourniquetDrill',
  branch: 'survival',
  tier: 2,
  title: 'Tourniquet Drill',
  blurb: 'Above the wound, below the panic. Loosen every twenty minutes, if convenient.',
  maxRanks: 3,
  minLevel: 9,
  requires: ['civilDefence'],
  statGrants: {},
  effects: [{ field: 'bleedoutSeconds', perRank: 0.09, condition: null }],
  damageModifiers: [],
} as const satisfies Perk;
